import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { computed, inject, Injectable, Signal } from '@angular/core';
import { APP_CONFIG } from '../../config/app-config';
import { DriverNameService } from '../../services/driver-name.service';

@Injectable()
export class DriverNameIdInterceptor implements HttpInterceptor {
  private readonly appConfig = inject(APP_CONFIG);
  private readonly driverNameService = inject(DriverNameService);

  private readonly driverNameId: Signal<string | null> = computed(
    () => this.driverNameService.driverName()?.id ?? null
  );

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Temporarily use the below check until the old API endpoints are migrated.
    const isRequestToNewApi = request.url.startsWith(this.appConfig.newApiUrl);
    const driverNameId = this.driverNameId();

    if (driverNameId && isRequestToNewApi) {
      const newHeaders = request.headers.append('X-Driver-Name', driverNameId);
      request = request.clone({ headers: newHeaders });
    }

    return next.handle(request);
  }
}
